function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import { filterStyledSystemMarginProps } from "../../style/utils";
import useMediaQuery from "../../hooks/useMediaQuery";
import useLocale from "../../hooks/__internal__/useLocale";
import tagComponent from "../../__internal__/utils/helpers/tags/tags";
import StyledLoader from "./loader.style";
import StyledLoaderSquare from "./loader-square.style";
export const Loader = ({
  variant = "default",
  "aria-label": ariaLabel,
  size = "medium",
  isInsideButton,
  isActive = true,
  ...rest
}) => {
  const l = useLocale();
  const reduceMotion = !useMediaQuery("screen and (prefers-reduced-motion: no-preference)");
  const loaderSquareProps = {
    isInsideButton,
    isActive,
    size,
    variant
  };

  // FE-6368 has been raised for the below, changed hex values for design tokens (when added)
  return /*#__PURE__*/React.createElement(StyledLoader, _extends({
    "aria-label": ariaLabel || l.loader.loading(),
    role: "progressbar"
  }, tagComponent("loader", rest), filterStyledSystemMarginProps(rest)), reduceMotion ? l.loader.loading() : /*#__PURE__*/React.createElement(React.Fragment, null, ["#13A038", "#0092DB", "#8F49FE"].map(color => /*#__PURE__*/React.createElement(StyledLoaderSquare, _extends({
    "data-role": "loader-square",
    key: color,
    backgroundColor: variant === "gradient" ? /* istanbul ignore next */color : "var(--colorsActionMajor500)"
  }, loaderSquareProps)))));
};
export default Loader;